import { ArchitectureDiagram } from './ArchitectureDiagram';
import { reliability, stack } from './content';
import { ChevronDownIcon } from './icons';

/**
 * For technical readers, folded away near the footer so it doesn't sit in a distributor's path.
 * Closed until opened (the footer's "For developers" opens it too); the content stays English.
 */
export const UnderTheHood = ({ summary }: { summary: string }) => (
  <details id="under-the-hood" className="lp-hood-details">
    <summary>
      <span className="lp-container lp-hood-summary">
        <span>{summary}</span>
        <span className="lp-hood-chevron">
          <ChevronDownIcon />
        </span>
      </span>
    </summary>
    <section className="lp-section lp-hood-section" lang="en" aria-labelledby="lp-hood-title">
      <div className="lp-container">
        <h2 id="lp-hood-title">Under the hood</h2>
        <p className="lp-section__intro">
          For technical readers: what it’s built with, how the pieces talk, and how it stays
          reliable.
        </p>

        <div className="lp-hood">
          <ArchitectureDiagram />
          <div>
            <h3 className="lp-hood__heading">Stack</h3>
            <dl className="lp-stack">
              {stack.map((group) => (
                <div key={group.area} className="lp-stack__group">
                  <dt>{group.area}</dt>
                  <dd>
                    {group.items.map((item) => (
                      <span key={item} className="lp-chip">
                        {item}
                      </span>
                    ))}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>

        <h3 className="lp-hood__heading lp-hood__heading--spaced">Reliability</h3>
        <ul className="lp-reliability">
          {reliability.map((r) => (
            <li key={r.title}>
              <h4>{r.title}</h4>
              <p>{r.body}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  </details>
);
